import { render, staticRenderFns } from "./lolth-valued-enum-label.vue?vue&type=template&id=21e218b4&"
import script from "./lolth-valued-enum-label.vue?vue&type=script&lang=ts&"
export * from "./lolth-valued-enum-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./lolth-valued-enum-label.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports